import {
  FilterGroupNode,
  FilterItemNode,
  KeyValuePair,
  ResourceExplorerFilterProvider,
} from "@/services/cloudchipr.api";

export const generateFilterTreeInCaseOfTagValues = (
  provider: ResourceExplorerFilterProvider,
  filterTree: FilterGroupNode | FilterItemNode | undefined,
  filterValue?: string,
): FilterGroupNode | FilterItemNode | undefined => {
  if (filterValue !== "no-tag-value") {
    return filterTree;
  }

  return {
    node_type: "group",
    operator: "and",
    items: [
      {
        node_type: "item",
        type: "tag",
        filter_provider: provider,
        value: { value: "" } as KeyValuePair,
        operator: "is",
      },
    ],
  };
};
